































































import AlgoliaSearchAutocomplete from '@algolia-search/components/organisms/SearchAutocomplete/AlgoliaSearchAutocomplete.vue';
import {
  computed,
  defineComponent,
  onMounted,
  useRoute,
  watch
} from '@nuxtjs/composition-api';
import { SfButton } from '@storefront-ui/vue';
import VaimoIconSVG from 'atoms/VaimoIconSVG.vue';
import VaimoTopNavigation from 'organisms/header/VaimoTopNavigation.vue';
import { storeToRefs } from 'pinia';

import { useCart, useUiNotification } from '~/composables';
import VaimoLogo from '~/diptyqueTheme/components/atoms/VaimoLogo.vue';
import { useScreenSize } from '~/diptyqueTheme/composable/useScreenSize';
import { useMegaMenuMobileStore } from '~/diptyqueTheme/stores/megaMenuMobile';

export default defineComponent({
  name: 'VaimoHeader',
  components: {
    SfButton,
    VaimoTopNavigation,
    VaimoLogo,
    AlgoliaSearchAutocomplete,
    VaimoIconSVG
  },
  props: {
    cartProductsQuantity: {
      type: Number,
      default: 0
    },
    transparentHeader: {
      type: Boolean,
      default: false
    },
    promoHeight: {
      type: Number,
      default: 0
    }
  },
  emits: ['account-toggle'],
  setup(props) {
    const route = useRoute();
    const megaMenuMobileStore = useMegaMenuMobileStore();
    const { isDesktopMenuOpen } = storeToRefs(megaMenuMobileStore);

    const { loadTotalQty: loadCartTotalQty } = useCart();
    const { isDesktop } = useScreenSize();
    const { notifications } = useUiNotification();

    const isCheckout = computed(() => {
      const checkout = route.value.path.includes('checkout');
      const success = route.value.path.includes('checkout/thank-you');
      return checkout && !success;
    });

    onMounted(async () => {
      if (isDesktop && !route.value.path.includes('checkout')) {
        await loadCartTotalQty();
      }
    });

    // set promo height CSS variable on :root
    const setRootPromoHeight = (value: number) => {
      if (typeof document !== 'undefined') {
        document.documentElement.style.setProperty(
          '--promo-banner-height-desktop',
          `${value}px`
        );
      }
    };

    onMounted(() => {
      setRootPromoHeight(props.promoHeight);
    });

    watch(
      () => props.promoHeight,
      (newVal) => {
        setRootPromoHeight(newVal);
      }
    );

    return {
      hasNotifications: computed(() => notifications.value.length > 0),
      isCheckout,
      isDesktopMenuOpen
    };
  }
});
